export default __webpack_public_path__ + "static/media/pension.icon.91f061a0.svg";